/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overdueenabled1Inputs */

const vi_overdueenabled1 = /** @type {(inputs: Overdueenabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn quá hạn`)
};

/**

* @param {Overdueenabled1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const overdueenabled1 = /** @type {((inputs?: Overdueenabled1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overdueenabled1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_overdueenabled1(inputs)
});
export { overdueenabled1 as "overdueEnabled" }